import { getIn } from 'formik'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Row } from 'reactstrap'
import { realEstateGeneralFields } from '../../common/forms/generalRealEstate/fields'
import { usePropertyGeneralFormSelectOptions } from '../../pages/Properties/hooks'
import AppPermissionsSwitcher from '../AppPermissionsSwitcher/AppPermissionsSwitcher'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import RecursiveForm from '../RecursiveForm'
import PropertyFormGeneralContext from './PropertyFormGeneralContext'

const PropertyFormGeneralTab = (props) => {
    const { children, formik, inputs, tabs, activeTab, handleTabChange, module, id, property } = props
    const { selectOptions, isPending: selectOptionsLoading } = usePropertyGeneralFormSelectOptions(
        id,
        property?.propertyService?.id,
        property?.propertyType?.id,
        property?.owner
    )

    return (
        <PropertyFormGeneralContext.Provider
            value={{
                formik,
                inputs,
                tabs,
                activeTab,
                handleTabChange,
                module,
                selectOptions,
                selectOptionsLoading,
            }}
        >
            <Row>{children}</Row>
        </PropertyFormGeneralContext.Provider>
    )
}

export const PropertyFormGeneralTabSide = () => {
    const { inputs, formik, module, selectOptions, selectOptionsLoading } = useContext(PropertyFormGeneralContext)

    return (
        <FormSideContainer>
            <AppPermissionsSwitcher permission="EditData" data={inputs.sideForm} module={module}>
                {({ newData }) => (
                    <RecursiveForm
                        inputs={newData}
                        subform="general"
                        formik={formik}
                        selectOptions={selectOptions}
                        selectOptionsLoading={selectOptionsLoading}
                    />
                )}
            </AppPermissionsSwitcher>
        </FormSideContainer>
    )
}

export const PropertyFormGeneralTabMain = () => {
    const { t } = useTranslation()

    const { inputs, formik, tabs, activeTab, handleTabChange, module, selectOptions, selectOptionsLoading } = useContext(PropertyFormGeneralContext)

    const propertyServiceId = getIn(formik?.values?.general, realEstateGeneralFields.PROPERTY_SERVICE_ID)
    const propertyTypeId = getIn(formik?.values?.general, realEstateGeneralFields.PROPERTY_TYPE_ID)

    return (
        <FormMainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange}>
            {propertyServiceId && propertyTypeId ? (
                <AppPermissionsSwitcher permission="EditData" data={inputs.mainForm} module={module}>
                    {({ newData }) => (
                        <RecursiveForm
                            inputs={newData}
                            subform="general"
                            formik={formik}
                            selectOptions={selectOptions}
                            selectOptionsLoading={selectOptionsLoading}
                        />
                    )}
                </AppPermissionsSwitcher>
            ) : (
                <Row>
                    <Col>
                        <p className="text-center">{t('form.property.description.message')}</p>
                    </Col>
                </Row>
            )}
        </FormMainContainer>
    )
}

export default PropertyFormGeneralTab
